import ISPGetItemResponse, {
  IMediaTransformListSchema,
  IMediaTransformItemSchema,
  ISPListRow
} from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { IFaceted } from '@ms/items-view/lib/private/models/Facet';
import { listMediaTransformFacet, itemMediaTransformFacet } from '../../models/facets/MediaTransformFacets';

export function buildListMediaTransformFacets(response: ISPGetItemResponse): IFaceted {
  return listMediaTransformFacet.pack(buildListMediaTransformFacet(response));
}

export function buildItemMediaTransformFacets(row: ISPListRow): IFaceted {
  return itemMediaTransformFacet.pack(buildItemMediaTransformFacet(row));
}

const LIST_TRANSFORM_PROPERTIES: (keyof IMediaTransformListSchema)[] = [
  '.accessToken',
  '.callerStack',
  '.correlationId',
  '.driveAccessToken',
  '.driveAccessTokenV21',
  '.driveUrl',
  '.mediaBaseUrl',
  '.officeBundleGenerate',
  '.officeBundleGetFragment',
  '.pdfConversionUrl',
  '.pushChannelBaseUrl',
  '.thumbnailUrl',
  '.transformUrl',
  '.videoManifestUrl'
];

declare var window: Window & {
  // A hook that can be used to override the mediaBaseUrl in devhost scenarios
  __mediaBaseUrl?: string;
};

function buildListMediaTransformFacet(response: ISPGetItemResponse): IMediaTransformListSchema {
  const schema: IMediaTransformListSchema = {};

  const listSchema = response.ListSchema;

  if (listSchema) {
    for (const key of LIST_TRANSFORM_PROPERTIES) {
      let value = listSchema[key];
      if (value && key === '.mediaBaseUrl') {
        // When the srr cookie is set with a devhost url the base url will come back with the default response instead
        // of the correct one. Since this should only happen in development environments, it is ok to replace it
        // with something that might work instead of leaving it as something that will never work.
        value = value.replace('https://media.cloudapp.net', window.__mediaBaseUrl || 'https://northcentralus1-medias.svc.ms');
      }
      schema[key] = value;
    }
  }

  return schema;
}

const ITEM_TRANSFORM_PROPERTIES: (keyof IMediaTransformItemSchema)[] = [
  '.etag',
  '.ctag',
  '.fileType',
  '.hasBxf',
  '.hasOfficePreview',
  '.hasPdf',
  '.hasThumbnail',
  '.hasVideoManifest',
  '.spItemUrl',
  '.spResourceUrl'
];

function buildItemMediaTransformFacet(row: ISPListRow): IMediaTransformItemSchema {
  const schema: IMediaTransformItemSchema = {};

  for (const key of ITEM_TRANSFORM_PROPERTIES) {
    schema[key] = row[key];
  }

  return schema;
}
